import React__default, { useContext } from 'react';

const StytchClientContext = React__default.createContext({
    client: null
});
const useAdminPortalContext = ()=>useContext(StytchClientContext);
const useAdminPortalUIConfig = ()=>useAdminPortalContext().config;
const useAdminPortalOrgUIConfig = useAdminPortalUIConfig;
const useAdminPortalMemberManagementUIConfig = useAdminPortalUIConfig;
const useAdminPortalSSOUIConfig = useAdminPortalUIConfig;

export { StytchClientContext, useAdminPortalContext, useAdminPortalMemberManagementUIConfig, useAdminPortalOrgUIConfig, useAdminPortalSSOUIConfig, useAdminPortalUIConfig };
//# sourceMappingURL=StytchClientContext.mjs.map
